import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { listSites, updateSite } from "@/api/client";

interface SiteFilters {
  studyId?: string;
  status?: string;
  country?: string;
  connectionIds?: string[];
  limit?: number;
  startAfter?: string;
}

export function useSites(filters?: SiteFilters) {
  return useQuery({
    queryKey: ["sites", filters],
    queryFn: () => listSites(filters ?? {}),
    staleTime: 2 * 60 * 1000,
  });
}

export function useSite(studyId: string | undefined, siteId: string | undefined) {
  return useQuery({
    queryKey: ["site", studyId, siteId],
    queryFn: () => listSites({ studyId: studyId! }),
    enabled: !!studyId && !!siteId,
    select: (data) => data.sites.find((s) => s.id === siteId) ?? null,
    staleTime: 2 * 60 * 1000,
  });
}

export function useUpdateSite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateSite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sites"] });
    },
  });
}
